<template>
  <v-app>
    <v-main style="background-color: rgb(173,46,27);">
      <!-- 点检系统视差图 -->
      <!-- <v-img src="../src/assets/getImage.png" width="35%" class="mt-2"></v-img> -->
      <v-img  src="../assets/视差图.png"></v-img>
    <v-container>
    <!-- <v-divider dark></v-divider> -->
    <!-- 点检系统标题 -->
    <p class="mt-3" style="color: #fff; font-size: 3vmax; align-items: center;" align="center">消防点检系统</p>
    <!-- 点检系统子标题 -->
    <!-- <v-card-subtitle class="mb-0 mb-3" align="center" style="margin: 0; padding: 0;">点检状态展示</v-card-subtitle> -->
    <!-- 点检系统状态卡片栏 -->
    <v-card  height="120" style="background-color:rgb(255, 255, 255)" class="mb-3">
        <v-card-subtitle class="mb-0">点检状态展示</v-card-subtitle>
        <v-card-text style="color: blue; align-items: center; font-size:20px;" align="center" class="mb-0">
        <v-chip small label color="transparent" style="font-size: 20px; color: #4cb29b; font-weight: bolder;">{{ status }}</v-chip>
        <div style="color: darkgray; font-size: 12px;">{{currentTime}}</div>
        </v-card-text>
      </v-card> 
      <!-- 点检系统消防档案栏 -->
      <v-card height="120" style="background-color:rgb(255, 255, 255);" class="mb-1">
        <v-card-subtitle class="mb-0">消防点检档案</v-card-subtitle>
        <v-card-text style="" >
          <div style=" text-align: center; align-self: center; align-items: center;" class="d-flex justify-space-around">
            <v-chip small label color="transparent" style="font-size: 24px; color: #4cb29b; font-weight: bolder;">{{ fromdata.sumNumber }}</v-chip>
            <v-chip small label color="transparent" style="font-size: 24px; color: #4cb29b; font-weight: bolder;">{{ fromdata.monthNumber }}</v-chip>
          </div>
        </v-card-text>
        <div class="d-flex justify-space-around">
        <v-chip class="ml-4" small label color="transparent" style="color: darkgray; font-size: 12px;">累计消防点检次数</v-chip>
        <v-chip class="mr-4" small label color="transparent" style="color: darkgray; font-size: 12px;">本月消防点检次数</v-chip>
      </div>
      </v-card> 
      <!-- 点检系统点检填报操作入口栏 -->
      <v-card style="background-color:rgb(255, 255, 255);" class="mt-3">
        <v-card-subtitle class="mb-0 mt-0">操作入口</v-card-subtitle>
      <v-container align="center">
      <v-card height="100" style="background-color: rgba(83,160,237,0.3);" class="mb-3" >
        <v-card-subtitle class="mb-0" style="font-size:18px; color: black; font-weight: 550;">点检记录</v-card-subtitle>
        <div>
        <div class="d-flex justify-space-between">
        <v-chip small label color="transparent" style="color: rgb(132, 132, 132);">请巡查人员按照要求实际填写</v-chip>
        <v-btn small depressed color="primary" class="mr-3" to="/abnormalHome">填写</v-btn>
      </div>
      </div>
      </v-card>
      <v-card height="100" style="background-color:  rgba(251, 128, 128, 0.2);" class="mb-3">
        <v-card-subtitle class="mb-0" style="font-size:18px; color: rgb(173,46,27); font-weight: 550;">异常记录</v-card-subtitle>
        <div class="d-flex justify-space-between">
        <v-chip small label color="transparent" style="color: rgb(132, 132, 132);">请巡查人员按照要求实际填写</v-chip>
        <v-btn small depressed color="#d63939" style="color: #fff;" class="mr-3" to="/check" >
          填写 
        </v-btn>
        </div>
      </v-card>
      <v-card height="100" style="background-color:  rgba(241, 156, 55, 0.2);">
        <v-card-subtitle class="mb-0" style="font-size:18px; color: black; font-weight: 550;">新增设备</v-card-subtitle>
        <div class="d-flex justify-space-between">
        <v-chip small label color="transparent" style="color: rgb(132, 132, 132);">请巡查人员按照要求实际填写</v-chip>
        <v-btn small depressed color="#e0800f" class="mr-3" to="/device" style="color: #fff;">
        添加 
        </v-btn>
        </div>
      </v-card>
    </v-container>
      </v-card> 
    </v-container>
    <!-- <router-view></router-view> -->
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'home',
data() { 
    return {  
        currentTime: '',
        lastTime:'',
        status: "正常",
        fromdata:{
        sumNumber: 0,
        monthNumber: 0,
      }
    }  
  },  
  mounted() {  
    this.updateTime()  
    setInterval(this.updateTime, 1000);
    this.homeSumNumber();
    // this.homeMonthNumber()
  },  
  methods: {  
    updateTime() {  
      const now = new Date()
      const year = now.getFullYear();
      const month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
      const day = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
      const hours = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
      const minutes = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes(); 
      const seconds = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds(); 
      const week = now.getDay();
      const weekArr = [ '星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六' ];
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekArr[week]}`
    },

    async homeSumNumber(){
      try {  
        const response = await this.$axios.get('http://192.168.3.3:18081/abnormal/getAbnormalCount');  
        // console.log('响应数据:', response.data);  
        this.fromdata.sumNumber = response.data; // 假设 response.data 是你的最终数据

        const response1 = await this.$axios.get('http://192.168.3.3:18081/abnormal/getAbnormalByMonth');  
        // console.log('响应数据:', response1.data);  
        this.fromdata.monthNumber = response1.data; 

    } catch (error) {  
        alert("请求失败！");  
        console.error('请求失败:', error);  
    }  
    },

  },  
  beforeDestroy() {  
    clearInterval(this.timer)  
  }  
}  
</script>